<template>
  <div class="table-users">

    <div class="the-table">
      <div class="headers">
        <div class="row">
          <span>Name</span>
          <span>Email</span>
          <span v-if="showTeams">Distributor</span>
          <span v-if="showParentUser">Belongs to</span>
          <span v-if="showParentUser">Attached Users</span>
          <span>Role</span>
          <span>Options</span>
        </div>
      </div>
      <div class="table" v-if="userData && userData.length > 0">
        <div 
          class="row"
          v-for="(user, index) in userData"
          :key="index"
          :class="[
            user.should_delete ? 'deleting' : ''
          ]"
          >
          <span>
            <div 
              class="avatar" 
              :style="{
                backgroundImage: `url(${user.profile_photo_url})`
              }"
              />
            <div class="user-name">{{ user.name }}</div>
          </span>
          <span>{{ user.email }}</span>
          
          <span v-if="showTeams">
            <div v-if="user.teams && user.teams.length > 0">
              <em
                v-for="(team, index) in user.teams"
                :key="index"
                >
                {{ team.name }}
              </em>
            </div>
            <div v-else>
              <em>N/A</em>
            </div>
          </span>
          <span v-if="showParentUser">
            <div v-if="user.attached_to_user.length > 0">
              {{ user.attached_to_user[0].name }}
            </div>
            <div v-else>
              <em>N/A</em>
            </div>
          </span>
          <span v-if="showParentUser">
            <div v-if="user.attached_users_count">
              <Link :href="`/admin/user/${user.id}/attached-users`">
                {{ user.attached_users_count }}
              </Link>
            </div>
            <div v-else>
              <em>0</em>
            </div>
          </span>
          <span>{{ user.should_delete ? 'Deleting...' : niceRoleName(user.user_type) }}</span>
          <span>
            <Link
              :href="`/admin/edit-user/${user.id}`" 
              v-if="$page.props.user.user_type == 'admin' && user.id != 1 && !user.should_delete"
              >
              <i class="fal fa-pencil"/>
            </Link>
            <i 
              class="fal fa-trash-alt"
              v-if="$page.props.user.user_type == 'admin' && user.id != 1 && !user.should_delete"
              @click="deleteUser(user.id, user.user_type)"
              />
          </span>
        </div>
      </div>
      <div v-else class="no-data">
        No users found...
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Link
  },
  props: {
    userData: Object,
    showDate: {
      type: Boolean,
      default: true
    },
    showTeams: {
      type: Boolean,
      default: true
    },
    showParentUser: {
      type: Boolean,
      default: false
    }
  },
  mounted(){
    // console.log('users', this.userData)
  },
  methods: {
    niceDate(dateString){
      let theDate = new Date(dateString)
      return moment(theDate).format('DD/MM/YYYY')
    },
    deleteUser(id, type){
      let message = ''

      if(type == 'admin'){
        message = 'Are you sure you wish to delete this user? You CANNOT undo this!'
      }else{
        message = 'Are you sure you wish to delete this user? This action WILL REMOVE ALL Cases and files tied to this user. You CANNOT undo this! If you need to backup any of this user\'s files then you should press cancel and back them up before deleting.'
      }

      if(confirm(message)){
        this.$inertia.post(`/admin/delete-user`, {
          id: id
        })
      }
    },
    niceRoleName(type){
      switch(type){
        case 'admin':
          return 'Meshworks Admin'
          break
        case 'global_viewer':
          return 'Meshworks Viewer'
          break
        case 'team_admin':
          return 'Distributor Admin'
          break
        case 'team_user':
          return 'Distributor User'
          break
        case 'viewer':
          return 'Viewer'
          break
        case 'user':
          return 'User'
          break
      }
    }
  },
}
</script>

<style lang="sass" scoped>

.table-users
  width: 100%
  display: flex
  flex-direction: column

  .heading
    width: 100%
    margin-bottom: 30px

    .title
      font-size: 24px
      font-weight: 700
      font-family: 'Roboto Condensed', sans-serif
      color: #252525
      line-height: 1.1
      margin-bottom: 8px

    .desc
      font-size: 16px
      font-weight: 400
      font-family: 'Roboto', sans-serif
      color: #6a6a6a
      line-height: 1.1

  .the-table
    .row
      display: grid
      grid-template-columns: 1fr 1.1fr 0.6fr 0.9fr 0.6fr 0.6fr 0.3fr

      span
        display: flex
        align-items: center

        a
          text-decoration: underline
          color: #00d
          transition: all 300ms

          &:hover
            opacity: 0.7

        &:last-child
          justify-content: flex-end

    @media (max-width: 900px)
      overflow-x: auto
      
      .row
        display: flex

        span
          min-width: 190px


    .headers
      font-size: 18px
      font-weight: 700
      font-family: 'Roboto Condensed', sans-serif
      color: #252525
      line-height: 1.1
      margin-bottom: 10px

      .row
        padding: 0 20px


    .table
      width: 100%
      background-color: #fff
      border-radius: 8px
      box-shadow: 0 1px 3px rgba(#000, 0.12)
      padding: 0 20px

      .row
        font-size: 14px
        font-weight: 400
        font-family: 'Roboto', sans-serif
        color: #252525
        line-height: 1.1
        height: 60px
        border-bottom: 1px solid #d0d0d0
        align-items: center

        &.deleting
          color: darken(#f00, 10%)

        &:last-child
          border-bottom: none

        .fal
          font-size: 22px
          color: #252525
          margin-left: 20px
          transition: all 300ms
          cursor: pointer

          &:hover
            opacity: 0.7

        .avatar
          width: 32px
          height: 32px
          border-radius: 50%
          overflow: hidden
          border: 1px solid rgba(#000, 0.1)
          background-size: cover

        .user-name
          margin-left: 15px

  .no-data
    width: 100%
    background-color: rgba(#fff, 0.2)
    border-radius: 8px
    box-shadow: 0 1px 3px rgba(#000, 0.12)
    padding: 0 20px
    height: 60px
    display: flex
    justify-content: center
    align-items: center

</style>
